import React, { useState, useRef, useEffect } from 'react';
import styles from '../styles/Navbar.module.css';
import { useNavigate } from 'react-router-dom';

function AccountModal({ open, onClose, admin, setAdmin }) {
  const [form, setForm] = useState(admin);
  const [pw, setPw] = useState({ current: '', new: '', confirm: '' });
  const [msg, setMsg] = useState('');
  const [showPwForm, setShowPwForm] = useState(false);

  useEffect(() => { setForm(admin); }, [admin, open]);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handlePwChange = e => setPw({ ...pw, [e.target.name]: e.target.value });

  const handleSave = () => {
    setAdmin(form);
    setMsg('Profile updated!');
    setTimeout(() => setMsg(''), 1500);
    onClose();
  };
  const handlePwSubmit = e => {
    e.preventDefault();
    if (!pw.current || !pw.new || !pw.confirm) return setMsg('Fill all password fields.');
    if (pw.new !== pw.confirm) return setMsg('New passwords do not match.');
    setMsg('Password reset! (dummy)');
    setPw({ current: '', new: '', confirm: '' });
    setShowPwForm(false);
    setTimeout(() => setMsg(''), 1500);
  };
  const handlePwCancel = () => {
    setShowPwForm(false);
    setPw({ current: '', new: '', confirm: '' });
  };
  if (!open) return null;
  return (
    <div className={styles.accountModalOverlay}>
      <div className={styles.accountModalCard}>
        <button onClick={onClose} className={styles.accountModalClose}>&times;</button>
        <h2 className={styles.accountModalTitle} style={{ textAlign: 'center' }}>My Account</h2>
        <div className={styles.accountModalSection}>
          <label className={styles.accountModalLabel}>Name</label>
          <input name="name" value={form.name} onChange={handleChange} className={styles.accountModalInput} />
          <label className={styles.accountModalLabel}>Email</label>
          <input name="email" value={form.email} onChange={handleChange} className={styles.accountModalInput} />
          <label className={styles.accountModalLabel}>Mobile</label>
          <input name="mobile" value={form.mobile} onChange={handleChange} className={styles.accountModalInput} />
          <label className={styles.accountModalLabel}>Gender</label>
          <select name="gender" value={form.gender} onChange={handleChange} className={styles.accountModalSelect}>
            <option>Male</option><option>Female</option><option>Other</option>
          </select>
        </div>
        <div className={styles.accountModalActions}>
          <button onClick={handleSave} className={styles.accountModalSave}>Save</button>
          <button onClick={onClose} className={styles.accountModalCancel}>Cancel</button>
        </div>
        <hr className={styles.accountModalDivider} />
        {!showPwForm ? (
          <button onClick={() => setShowPwForm(true)} className={styles.accountModalPwBtn}>Reset Password</button>
        ) : (
          <form onSubmit={handlePwSubmit} className={styles.accountModalPwForm}>
            <input type="password" name="current" value={pw.current} onChange={handlePwChange} placeholder="Current Password" className={styles.accountModalPwInput} autoComplete="current-password" />
            <input type="password" name="new" value={pw.new} onChange={handlePwChange} placeholder="New Password" className={styles.accountModalPwInput} autoComplete="new-password" />
            <input type="password" name="confirm" value={pw.confirm} onChange={handlePwChange} placeholder="Confirm New Password" className={styles.accountModalPwInput} autoComplete="new-password" />
            <div className={styles.accountModalPwActions}>
              <button type="submit" className={styles.accountModalPwBtn}>Reset Password</button>
              <button type="button" onClick={handlePwCancel} className={styles.accountModalPwCancel}>Cancel</button>
            </div>
          </form>
        )}
        {msg && <div className={styles.accountModalMsg + ' ' + (msg.includes('success') || msg.includes('updated') ? styles.accountModalMsgSuccess : styles.accountModalMsgError)}>{msg}</div>}
      </div>
    </div>
  );
}

const Navbar = ({ onSidebarToggle }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [admin, setAdmin] = useState({
    name: 'John Doe',
    email: 'john.doe@example.com',
    mobile: '+91 9876543210',
    gender: 'Male',
  });

  const handleLogout = () => {
    localStorage.removeItem('admin');
    localStorage.removeItem('isLoggedIn');
    navigate('/');
  };

  // Close menu on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <header className={styles.navbarSimple}>
      <div className={styles.leftSimple}>
        {onSidebarToggle && (
          <button onClick={onSidebarToggle} className={styles.menuBtn} aria-label="Open sidebar">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <rect y="5" width="24" height="2" rx="1" fill="#18181b"/>
              <rect y="11" width="24" height="2" rx="1" fill="#18181b"/>
              <rect y="17" width="24" height="2" rx="1" fill="#18181b"/>
            </svg>
          </button>
        )}
        <img src="https://main.d34z81njze67ob.amplifyapp.com/assets/logo-D94pH_jU.png" alt="Logo" className={styles.logoImgSimple} />
      </div>
      <div className={styles.rightSimple} style={{ position: 'relative', marginRight: '32px' }}>
        <button
          className={styles.logoutBtnSimple}
          onClick={() => setMenuOpen((open) => !open)}
          title="User menu"
          aria-haspopup="true"
          aria-expanded={menuOpen}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="#18181b" stroke="#111" strokeWidth="2"/>
            <circle cx="12" cy="10" r="3" fill="#fff"/>
            <ellipse cx="12" cy="16" rx="5" ry="3" fill="#fff"/>
          </svg>
          <span style={{ position: 'absolute', left: '-9999px' }}>User menu</span>
        </button>
        {menuOpen && (
          <div ref={menuRef} className={styles.userMenuSimple} style={{ right: '24px', left: 'auto', marginTop: '9px', }}>
            <div
              className={styles.userMenuItemSimple}
              onClick={() => { setMenuOpen(false); setModalOpen(true); }}
            >
              My Account
            </div>
            <div className={styles.userMenuItemDividerSimple}></div>
            <div
              className={styles.userMenuItemSimple}
              onClick={handleLogout}
            >
              Logout
            </div>
          </div>
        )}
      </div>
      <AccountModal open={modalOpen} onClose={() => setModalOpen(false)} admin={admin} setAdmin={setAdmin} />
    </header>
  );
};

export default Navbar;